import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { MODAL_CONTENT_SIZING, MODAL_SIZING } from "../../../utils/constants";
import { BenchmarkReference } from "../../../api/benchmark/benchmarkApi";
import { BenchmarkReferenceForm } from "./BenchmarkReferenceForm";

interface BenchmarkReferenceModalProps {
    show: boolean;
    onClose: () => void;
    rowData?: BenchmarkReference;
    onSave?: (data: BenchmarkReference) => void;
}

export const BenchmarkReferenceModal: FunctionComponent<BenchmarkReferenceModalProps> = ({ show, onClose, rowData }) => {
    return (
        <Modal isOpen={show} onClose={onClose} size={MODAL_SIZING} isCentered motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent style={{ ...MODAL_CONTENT_SIZING }} overflowY="auto">
                <ModalHeader>{rowData ? "Edit Benchmark Reference" : "Add Benchmark Reference"}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <BenchmarkReferenceForm show={show} onClose={onClose} rowData={rowData} />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
